import React from 'react';
import PagesLink from './PagesLink.jsx';
import {PageNumLink} from './Paginator.styled.jsx';

export function createPageLinksTemplate({
  FirstPageIconActive,
  FirstPageIconInactive,
  PreviousIconActive,
  PreviousIconInactive,
  NextIconActive,
  NextIconInactive,
  LastPageIconActive,
  LastPageIconInactive,   
}) {
  const FirstPageLink = (options) => (
    <PagesLink
      onClick={!options.disabled ? options.onClick : undefined} 
      disabled={options?.disabled}
      margin=' 0 5px 0 0'
      src={options.disabled
        ? FirstPageIconInactive
        : FirstPageIconActive}
      alt='first page'
    />
  );
  FirstPageLink.displayName = 'FirstPageLink';

  const PrevPageLink = (options) => (
    <PagesLink
      onClick={options?.onClick}
      disabled={options?.disabled}
      src={options?.disabled
        ? PreviousIconInactive
        : PreviousIconActive}
      alt='previous page'
    />
  );
  PrevPageLink.displayName = 'PrevPageLink';

  const PageLinks = (options) => {
    const isLength = (options.currentPage + 1).toString().length;
    const pageNo = options.page + 1;
    const baseMargin = pageNo >= 1000 ? '3px' : pageNo > 99 ? '7px' : '5px';
    const hasLength = isLength > 2;
    const selected = options.currentPage === options.page;
    return (
      <PageNumLink
        pageNumber={options.page +1}
        isLength={isLength}
        baseMargin={baseMargin}
        hasLength={hasLength}
        selected={selected} 
        onClick={options.onClick}
      >
        {options.page + 1}
      </PageNumLink>
    );
  };
  PageLinks.displayName = 'PageLinks';

  const NextPageLink = (options) => (
    <PagesLink
      onClick={options.onClick}
      disabled={options?.disabled}
      src={options.disabled ? NextIconInactive : NextIconActive}
      alt='next page'
    />
  );
  NextPageLink.displayName = 'NextPageLink';

  const LastPageLink = (options) => (
    <PagesLink
      onClick={!options.disabled ? options.onClick : undefined} 
      disabled={options?.disabled}
      margin='0 0 0 5px'
      src={options.disabled
        ? LastPageIconInactive
        : LastPageIconActive}
      alt='last page'
    />
  );
  LastPageLink.displayName = 'LastPageLink';

  return {
    layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink',
    FirstPageLink,
    PrevPageLink,
    PageLinks,
    NextPageLink,
    LastPageLink,
  };
}